import * as yup from 'yup'

export const validationNewFamily = yup.object().shape({
  descripcion: yup.string().required('Este campo es obligatorio'),
})

export const validationNewProduct = yup.object().shape({
  producto: yup.string().required('Este campo es obligatorio'),
})
export const validationUpdateProduct = yup.object().shape({
  nombre: yup.string().required('Este campo es obligatorio'),
})

// export const validationEditProduct = yup.object().shape({
//   peso: yup.number()
//     .typeError("Debe ser un número")
//     .min(0, "Ingrese un número positivo")
// })
